export default __webpack_public_path__ + "static/media/Offer.ed28cfa5.svg";